import React, { useEffect, useRef, useState } from "react";
import { MerchantUserModel } from "../../../models/merchantUser";
import { MerChantModel } from "../../../models/merChantModel";
import axios from "../../../lib/axios";
import { MERCHANT_STORE_FIND_MANY } from "../../../lib/endpoints/merchants";
import { RoleAndPermissionModel } from "../../../models/roleAndPermission";
import { useTranslation } from "react-i18next";
import ProvinceData from "../../../data/lao_province.json";
import {
  CREATE_MERCHANT_USER,
  FIND_ROLE_AND_PERMISSION,
  UPDATE_MERCHANT_USER,
  UPDATE_MERCHANT_USER_PROFILE,
} from "../../../lib/endpoints/merchantUser";
import { generateImageFileNameWithRandomName } from "../../../utils/generateImageFileName";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { IMAGE_MERCHANT_ROOT_URL } from "../../../constants/imageUrl";
import { ProvinceModel } from "../../../models/province.model";
import { DistrictModel } from "../../../models/district.model";

const dataProvinceFromJson: ProvinceModel[] = ProvinceData;

interface Props {
  onClose: VoidFunction;
  selectedData: MerchantUserModel;
  onFetchData: Function;
  setSelected: Function;
}

export const useFormJiffyStaffController = ({
  onClose,
  selectedData,
  onFetchData,
  setSelected,
}: Props) => {
  const authData: MerchantUserModel = useSelector(
    (state: RootState) => state?.auth?.data ?? null!
  );
  const [roleAndPermissionData, setRoleAndPermissionData] = useState<
    RoleAndPermissionModel[]
  >([]);
  const [roleAndPermissionValue, setRoleAndPermissionValue] = useState<string>(
    null!
  );
  // const [selectedGender, setSelectedGender] = useState<GenderEnum>(GenderEnum.OTHER);
  const [loadingFetchData, setLoadingFetchData] = useState<boolean>(true);

  const [banValue, setBanValue] = useState<boolean>(false);
  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<any>(null!);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [loadingConfirmForm, setLoadingConfirmForm] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);

  const firstName = useRef<HTMLInputElement>(null!);
  const lastName = useRef<HTMLInputElement>(null!);
  const tel = useRef<HTMLInputElement>(null!);
  const email = useRef<HTMLInputElement>(null!);
  const village = useRef<HTMLInputElement>(null!);
  const userName = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);

  const [provinceValue, setProvinceValue] = useState<string>(null!);
  const [districtsValue, setDistrictsValue] = useState<string>(null!);
  const [districtsData, setDistrictsData] = useState<DistrictModel[]>([]);

  const { t } = useTranslation("global");

  const handleFetchData = async () => {
    try {
      setLoadingFetchData(true);
      const roleResponse = await axios.post(FIND_ROLE_AND_PERMISSION);
      if (roleResponse?.data?.length > 0) {
        setRoleAndPermissionData(
          roleResponse.data?.filter((item: any) => item?.role_type === "STAFF")
        );
        setRoleAndPermissionValue(
          roleResponse.data?.filter(
            (item: any) => item?.role_type === "STAFF"
          )[0]?.id
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingFetchData(false);
    }
  };

  const handleBanUser = (newValue: boolean) => {
    setBanValue(newValue);
  };

  const handleChangeRoleAndPermission = (newValue: string) => {
    setRoleAndPermissionValue(newValue);
  };

  const handleSelectedImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  const handleRest = () => {
    setSelected(null);
    setImageToShow(null);
    setImageFile(null);
    setRoleAndPermissionValue(null!);

    if (firstName.current) firstName.current.value = "";
    if (lastName.current) lastName.current.value = "";
    if (tel.current) tel.current.value = "";
    if (email.current) email.current.value = "";
    if (village.current) village.current.value = "";
    if (userName.current) userName.current.value = "";
    if (password.current) password.current.value = "";
  };

  const handleValidateForm = () => {
    if (!selectedData && !imageFile) {
      setErrorMessage("Please select an image.");
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.current?.value)) {
      setErrorMessage("Please enter a valid email address.");
      return false;
    }
    const laosTelRegex = /^20\d{8}$/;
    if (!laosTelRegex.test(tel.current?.value)) {
      setErrorMessage("Please enter a valid Laos phone number.");
      return false;
    }
    if (!provinceValue) {
      setErrorMessage("Please select a province.");
      return false;
    }
    if (!districtsValue) {
      setErrorMessage("Please select a districts.");
      return false;
    }
    if (!password.current || password.current.value.length < 6) {
      setErrorMessage("Password must be at least 6 characters long.");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleOpenConfirmForm = (e: any) => {
    e.preventDefault();
    if (handleValidateForm()) {
      setOpenConfirm(true);
    }
  };

  const handleSubmit = () => {
    if (selectedData?.id) {
      handleEditMerchantUser();
    } else {
      handleCreateMerchantUser();
    }
  };

  const handleCreateMerchantUser = async () => {
    try {
      setLoadingConfirmForm(true);
      console.log("1");

      const formUser = {
        merchantId: authData?.merchantId,
        username: userName.current.value,
        password: password.current.value,
        roleId: roleAndPermissionValue,
      };

      const res = await axios.post(CREATE_MERCHANT_USER, formUser);
      console.log("res", res);

      console.log("1");
      const profileId = res?.data?.profile?.id;

      const formData: any = new FormData();
      formData.append("firstname", firstName.current.value);
      formData.append("lastname", lastName.current.value);
      formData.append("tel", tel.current.value);
      formData.append("email", email.current.value);
      formData.append("village", village.current.value);
      formData.append("city", districtsValue);
      formData.append("province", provinceValue);
      formData.append("file", generateImageFileNameWithRandomName(imageFile));
      console.log("1");

      await axios.patch(UPDATE_MERCHANT_USER_PROFILE + profileId, formData);
      console.log("1");
      await onFetchData();
      handleRest();
      onClose();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        console.log("getError == ", getErrorMessage);
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t("Server error please try again") || "");
      }
    } finally {
      setLoadingConfirmForm(false);
      setOpenConfirm(false);
    }
  };

  const handleEditMerchantUser = async () => {
    try {
      setLoadingConfirmForm(true);
      const inputForm = {
        roleId: roleAndPermissionValue,

        isBan: banValue,
      };
      await axios.patch(UPDATE_MERCHANT_USER + selectedData?.id, inputForm);
      const formData: any = new FormData();
      formData.append("firstname", firstName.current.value);
      formData.append("lastname", lastName.current.value);
      formData.append("tel", tel.current.value);
      formData.append("email", email.current.value);
      formData.append("village", village.current.value);
      formData.append("city", districtsValue);
      formData.append("province", provinceValue);
      if (imageFile) {
        formData.append("file", generateImageFileNameWithRandomName(imageFile));
      }
      await axios.patch(
        UPDATE_MERCHANT_USER_PROFILE + selectedData?.profile?.id,
        formData
      );
      await onFetchData();
      handleRest();
      onClose();
    } catch (error: any) {
      console.log("error=", error);
      try {
        const getErrorMessage: string = error.response.data.message;
        console.log("getError == ", getErrorMessage);
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t("Server error please try again") || "");
      }
    } finally {
      setLoadingConfirmForm(false);
      setOpenConfirm(false);
    }
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {
    if (selectedData) {
      firstName.current.value = selectedData?.profile?.firstname;
      lastName.current.value = selectedData?.profile?.lastname;
      tel.current.value = selectedData?.profile?.tel;
      email.current.value = selectedData?.profile?.email;
      village.current.value = selectedData?.profile?.village;
      userName.current.value = selectedData?.username;
      setRoleAndPermissionValue(selectedData?.roleId);
      setBanValue(selectedData?.isBan);
      setImageToShow(
        IMAGE_MERCHANT_ROOT_URL + selectedData?.profile?.image?.url
      );
      setProvinceValue(selectedData.profile?.province);
      setDistrictsValue(selectedData.profile?.city);
    }
    handleFetchData();
  }, [selectedData]);

  useEffect(() => {
    if (provinceValue) {
      const districtData = dataProvinceFromJson.filter(
        (item) => item?.provinceNameLA === provinceValue
      )[0]?.districts;

      if (districtData?.length > 0) {
        setDistrictsData(districtData);
        setDistrictsValue(districtData[0]?.districtNameLA);
      } else {
        setDistrictsData(districtData);
        setDistrictsValue(null!);
      }
      if (selectedData) {
        setDistrictsValue(selectedData?.profile?.city);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceValue]);

  return {
    handleBanUser,
    banValue,
    handleSelectedImage,
    imageToShow,
    openConfirm,
    handleOpenConfirmForm,
    handleCloseConfirmForm,
    errorMessage,
    handleChangeRoleAndPermission,
    roleAndPermissionValue,
    roleAndPermissionData,
    firstName,
    lastName,
    tel,
    email,
    village,
    userName,
    password,
    handleSubmit,
    loadingConfirmForm,
    handleRest,
    handleEditMerchantUser,
    loadingFetchData,
    districtsData,
    districtsValue,
    provinceValue,
    handleSelectedProvince: (e: any) => setProvinceValue(e.target.value),
    handleSelectedDistrict: (e: any) => setDistrictsValue(e.target.value),
    ProvinceData,
  };
};
